<template>
  <section class="relative lg:py-24 py-16" id="contact">
    <div class="container relative">
      <div class="grid grid-cols-1 pb-6 text-center">
        <h3 class="font-semibold text-2xl leading-normal mb-4">{{ $t("form.get_in_touch") }}</h3>
        <p class="text-slate-400 max-w-xl mx-auto">
          {{ $t("form.description") }}
        </p>
      </div>

      <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
        <div class="lg:col-span-7 md:col-span-6">
          <img src="../assets/images/contact.svg" alt="Contact">
        </div>

        <div class="lg:col-span-5 md:col-span-6">
          <div class="lg:ms-5">
            <div class="bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-700 p-6">
              <form @submit.prevent="sendEmail">
                <div class="grid lg:grid-cols-12 grid-cols-1 gap-3">
                  <div class="lg:col-span-6">
                    <label for="name" class="font-semibold">{{ $t("form.name") }}</label>
                    <input v-model="form.name" id="name" type="text" :placeholder="$t('form.nameph')"
                      class="input-field" required
                      @invalid="setValidationMessage($event, 'required')"
                      @input="resetValidation($event)"
                    >
                  </div>

                  <div class="lg:col-span-6">
                    <label for="email" class="font-semibold">{{ $t("form.email") }}</label>
                    <input v-model="form.email" id="email" type="email" :placeholder="$t('form.emailph')"
                      class="input-field" required
                      @invalid="setValidationMessage($event, 'email')"
                      @input="resetValidation($event)"
                    >
                  </div>

                  <div class="lg:col-span-12">
                    <label for="subject" class="font-semibold">{{ $t("form.subject") }}</label>
                    <input v-model="form.subject" id="subject" :placeholder="$t('form.subjectph')"
                      class="input-field" required
                      @invalid="setValidationMessage($event, 'required')"
                      @input="resetValidation($event)"
                    >
                  </div>

                  <div class="lg:col-span-12">
                    <label for="comments" class="font-semibold">{{ $t("form.message") }}</label>
                    <textarea v-model="form.message" id="comments" :placeholder="$t('form.messageph')"
                      class="input-field h-28" required
                      @invalid="setValidationMessage($event, 'required')"
                      @input="resetValidation($event)"
                    ></textarea>
                  </div>
                </div>
                <button type="submit" class="h-10 px-6 tracking-wide inline-flex items-center justify-center font-medium rounded-md bg-teal-500 text-white mt-2">
                  {{ $t("form.submit") }}
                </button>
              </form>

              <!-- Komunikaty o sukcesie lub błędzie -->
              <p v-if="messageStatus" :class="messageClass" class="mt-3">{{ messageStatus }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { useI18n } from "vue-i18n";
import { ref } from "vue";

export default {
  setup() {
    const { t } = useI18n();
    const form = ref({ name: "", email: "", subject: "", message: "" });
    const messageStatus = ref("");
    const messageClass = ref("");

    // Walidacja pól
    const setValidationMessage = (event, type) => {
      if (type === "required" && event.target.value.trim() === "") {
        event.target.setCustomValidity(t("form.validation.required"));
      } else if (type === "email" && !/\S+@\S+\.\S+/.test(event.target.value)) {
        event.target.setCustomValidity(t("form.validation.email"));
      } else {
        event.target.setCustomValidity("");
      }
      event.target.reportValidity();
    };

    const resetValidation = (event) => {
      event.target.setCustomValidity("");
    };

    const sendEmail = async () => {
  if (!form.value.name || !/\S+@\S+\.\S+/.test(form.value.email)) {
    messageStatus.value = t("form.validation.error");
    messageClass.value = "text-red-500 font-semibold";
    return;
  }

  try {
    const response = await axios.post(
      "https://www.ummonlab.com/mail.php", // Użyj HTTPS zamiast HTTP!
      new URLSearchParams(form.value), // Zamiana obiektu na format formularza
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } } // Wymuszenie poprawnego nagłówka
    );

    if (response.data === "success") {
      messageStatus.value = t("form.success");
      messageClass.value = "text-green-500 font-semibold";
      form.value = { name: "", email: "", subject: "", message: "" };
    } else {
      messageStatus.value = t("form.error");
      messageClass.value = "text-red-500 font-semibold";
    }
  } catch (error) {
    messageStatus.value = t("form.error");
    messageClass.value = "text-red-500 font-semibold";
    console.error("Email sending error:", error);
  }
};


    return { form, messageStatus, messageClass, sendEmail, setValidationMessage, resetValidation };
  }
};
</script>

<style scoped>
.input-field {
  @apply mt-2 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0;
}
</style>
